import { CreateMultiLegShippingEstimateByFuelResponse } from '@lune-climate/lune'
import { MultiLegShippingByFuelEstimateResult, PdfContent } from '@lune-fe/lune-components-lib'
import { Container } from '@lune-fe/lune-ui-lib'
import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getEstimatesByFuel } from 'endpoints/api'

const MultiLegShippingByFuelEstimateResultsPdf: FC = () => {
    const { id, token } = useParams<{ id: string; token: string }>()
    const [estimate, setEstimate] = useState<CreateMultiLegShippingEstimateByFuelResponse>()

    useEffect(() => {
        if (!id || !token || !!estimate) {
            return
        }
        getEstimatesByFuel(id, token).then((estimate) => {
            setEstimate(estimate)
            // window.loadingPdf = 'loaded' will be passed to pdf endpoint to  make sure
            // everything renders before generating the pdf
            setTimeout(() => {
                window.loadedPdf = 'loaded'
            }, 500)
        })
    }, [id])

    return (
        <Container
            maxWidth={'md'}
            sx={{
                my: 9,
                px: {
                    xs: 2,
                    sm: 2,
                    md: 2,
                    lg: 0,
                    xl: 0,
                },
            }}
        >
            <PdfContent>
                {estimate && (
                    <MultiLegShippingByFuelEstimateResult
                        estimate={{
                            ...estimate,
                            _meta: {
                                response: undefined,
                            },
                        }}
                        enableEmissionFactorLink={true}
                        isMobile={false}
                        pdfStructure={true}
                    />
                )}
            </PdfContent>
        </Container>
    )
}

export default MultiLegShippingByFuelEstimateResultsPdf
